<template>
  <div class="static-page">

    <section class="static-page__hero">
      <div class="static-page__hero-backdrop">
        <img class="static-page__hero-image" src="assets/images/travelc/statics/about-hero.jpg" alt="viaggia con noi hero" />
      </div>
    </section>

    <section class="section">
      <b-container>
        <h2 class="vb-heading h3 mb-4" v-html="config.site.brand + ' ' + config.site.payoff" />

        <p class="mb-5">
          <span class="text-primary medium">{{ config.site.brand }}</span> è un servizio di prenotazione viaggi dedicato al mondo del welfare aziendale. Su questo sito troverai proposte di viaggio provenienti da operatori e online travel agency di tutto il mondo e potrai progettare il tuo viaggio includendo voli, alloggi, tour, biglietti, esperienze o veri e propri pacchetti viaggio.
          <span class="text-primary">{{ config.site.brand }}</span> lo trovi dentro i portali dei migliori welfare provider italiani e internazionali.
        </p>

      </b-container>
    </section>

    <section class="section">
      <div class="static-page__form" id="contattaci">
        <b-container>
          <form-contatti
              :formTitle="title_request_form"
              :formSubTitle="subtitle_request_form"
              :label="'form-contatti-about'"
              :recipient="site.emailSupport"
          />
      </b-container>
      </div>
    </section>

  </div>
</template>


<script>
import Vue from "vue";
import FormContatti from '@components/blocks/form-contatti.vue'

export default {
  name: 'about',
  components:{
    'form-contatti': FormContatti,
  },
  props: {
  },
  created() {
  },
  data () {
    return {
      config: Vue.prototype.$config,
      site: Vue.prototype.$config.site,
      title_request_form: 'Hai bisogno di <span class=\'text-secondary\'>maggiori informazioni?</span> Contattaci!',
      subtitle_request_form: 'Compila il seguente form oppure scrivi una mail a <a href=\'mailto:' + Vue.prototype.$config.site.emailSupport + '\'>' + Vue.prototype.$config.site.emailSupport + '</a>',
    }
  },
  computed: {
  },
}
</script>


<style lang="scss" scoped>

  .static-page {

    &__hero {
      &-image {
        @include media-breakpoint-up(xl) {
          top: -5%;
        }
      }
    }
  }

</style>